module.exports = __webpack_public_path__ + "img/no-data.9ed35765.jpg";